import React from "react"

import {
    Nav, 
    Navbar, 
} from "react-bootstrap"

import logo from "../../../assets/navbarLogo.png"
import styles from "../../Stylesheets/Navigation"
import EMETLNavbarDropdown from "../EMETLNavbarDropdown"
import "./style.css"

const EMETLNavBar = () => {
    return (
        <div id="navbar">
            <Navbar 
                style={styles.navbar} 
                collapseOnSelect 
                expand="lg" 
                bg="dark" 
                variant="dark"
            >
                <Navbar.Brand href="/">
                    <img 
                        src={logo} 
                        style={styles.navBarLogoStyle} 
                        alt="EMETL" 
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className={"mr-auto"}>
                        {/* <Nav.Link href="/fieldManual">
                            Field Manual
                        </Nav.Link> */}
                        <Nav.Link 
                            eventKey={2} 
                            href="/Templates"
                        >
                            Templates
                        </Nav.Link>
                    </Nav>
                    <Nav
                        // align right
                        className="align-self-end flex-grow-1 justify-content-end"
                    >
                        <EMETLNavbarDropdown />
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}

export default EMETLNavBar
